var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('GitLogo',{staticClass:"icon",attrs:{"href":"https://github.com/Carnaux"}}),_c('LinkedinLogo',{staticClass:"style2",attrs:{"href":"https://www.linkedin.com/in/daniel-fernandes-101853138/"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }